import { colors } from '@/theme/colors';
import { CreditScore } from '../types';
import { cn } from '@/shadcn-ui/utils';
import { AgeRange } from '../types/age-range';

export interface CreditAgeSummaryProps {
  selectedCreditScoreId?: string;
  selectedIsOver25: boolean;
  selectedAgeRangeId?: string;
  creditScores: CreditScore[];
  ageRanges?: AgeRange[];
  className?: string;
  PRISTINE_HERO_PDP?: boolean;
}

export default function CreditAgeSummary({
  selectedCreditScoreId,
  selectedIsOver25,
  selectedAgeRangeId,
  creditScores,
  ageRanges,
  className,
  PRISTINE_HERO_PDP = false,
}: CreditAgeSummaryProps) {
  const selectedCreditScore = creditScores.find(
    (score) => score.id === selectedCreditScoreId
  )?.range;

  const displayAge = (() => {
    if (!ageRanges) {
      return selectedIsOver25 ? '25+' : 'under 25';
    }

    return ageRanges.find((range) => range.id === selectedAgeRangeId)?.display_name;
  })();

  return (
    <p
      className={cn(
        'body2 text-center decoration-flexcar-blue30 decoration-dotted transition-all duration-100',
        className,
        {
          'footer pointer-events-auto cursor-pointer text-left underline decoration-flexcar-neutral50 decoration-[2px] underline-offset-[4px] hover:text-flexcar-neutral1 hover:decoration-flexcar-blue50':
            PRISTINE_HERO_PDP,
        }
      )}
      {...(PRISTINE_HERO_PDP ? {} : { style: { textDecorationColor: colors.blue30 } })}
    >
      {selectedCreditScore === undefined ? (
        'Please select a credit score'
      ) : PRISTINE_HERO_PDP ? (
        `Prices based on age (${displayAge}) & credit (${selectedCreditScore})`
      ) : (
        <>
          Prices based on{' '}
          <span className="body2-strong cursor-pointer underline decoration-flexcar-neutral1 decoration-dotted decoration-[2px] underline-offset-[4px]">
            age ({displayAge}) & credit ({selectedCreditScore})
          </span>
        </>
      )}
    </p>
  );
}
